import(/* webpackMode: "eager" */ "/app/node_modules/sonner/dist/index.mjs")